<app-shopping-cart></app-shopping-cart>
<div class="workspace bg-radial">
  <top-bar [titleTranslationCode]="'NAVIGATION.PLANS'"
           [redirectLink]="'../../'"
           [defaultRedirectTranslationCodes]="true"
  >
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                <a class="pe-none">
                  {{ "NAVIGATION.PLANS" | translate }}
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ CourseFilterComponent.getLanguageTranslation(chosenCourse) | translate }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container mt-md-3">
    <app-course-filter (languageEmitter)="chosenCourse = $event"></app-course-filter>
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>
    <section class="mb-5">
      <app-shopping-cart-header (currencyChange)="currency = $event" [studentId]="studentId"></app-shopping-cart-header>
    </section>
    <app-english-products
      [currency]="currency"
      [chosenCourse]="chosenCourse"
      [studentId]="studentId"
      *ngIf="chosenCourse.filter == 'en' || chosenCourse.filter == ''"
    ></app-english-products>
    <app-spanish-products
      [currency]="currency"
      [chosenCourse]="chosenCourse"
      [studentId]="studentId"
      *ngIf="chosenCourse.filter == 'sp' || chosenCourse.filter == ''"
    ></app-spanish-products>
    <app-english-business-products
      [currency]="currency"
      [chosenCourse]="chosenCourse"
      [studentId]="studentId"
      *ngIf="chosenCourse.filter == 'en.bs' || chosenCourse.filter == ''"
    ></app-english-business-products>
    <app-kids-products
      [currency]="currency"
      [chosenCourse]="chosenCourse"
      [studentId]="studentId"
      *ngIf="chosenCourse.filter == 'en.ch' || chosenCourse.filter == ''"
    ></app-kids-products>
  </div>
</div>
